import { FC } from 'react';
import { ConditionalWrapperProps } from './types';

export const ConditionalWrapper: FC<ConditionalWrapperProps> = ({ condition, wrapper, children }) =>
	condition ? wrapper(children) : children;
